export function maskCnpj(value: string) {
  try {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
  } catch {
    return value
  }
}
